/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { useEffect, useRef } from "react";

import { TextField } from "@/frameworks/designStuff/components";
import { Utility } from "@/frameworks/libraries/utilities";
import { _T } from "@rfice/language";
import { SidebarID } from "@/frameworks/core/commons";
import { useCreateWorkGroup, useSidebarState } from "@/frameworks/core/hooks";

import * as S from "../emotion";

export default function NameField() {
	const nameRef = useRef<HTMLInputElement>(null);
	const {
		name,
		handlers: { handleReset, handleNameChange }
	} = useCreateWorkGroup();
	const sidebarState = useSidebarState();

	useEffect(() => {
		if (sidebarState.origin[SidebarID.CreateWorkGroup]?.isOpen === false) {
			handleReset(nameRef, () => handleNameChange(""));
		}
	}, [sidebarState.origin[SidebarID.CreateWorkGroup]?.isOpen]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleNameChange(Utility.sanitizeInput(e.target.value));
	};

	return (
		<S.FieldBox>
			<TextField
				ref={nameRef}
				label={_T("이름 (필수)")}
				value={name}
				placeholder={_T("그룹 이름을 입력해주세요")}
				onChange={handleChange}
				maxLength={50}
				subLabel={`${name.length} / 50`}
			/>
		</S.FieldBox>
	);
}
